import { Component, ComponentChildren } from 'preact';
import { Maybe, UserError } from '../../common/data.js';
import { generateId } from '../../common/util.js';
import { classNames, getEventValue } from '../lib/util.js';
import { InputHTMLAttributes } from 'preact/compat';

export interface LabeledInputProps extends Omit<Partial<InputHTMLAttributes<HTMLInputElement | HTMLSelectElement>>, 'value' | 'className'> {
	autocomplete?: string;
	select?: boolean;
	name?: string;
	value: Maybe<string | number>;
	attributes?: Record<string, any>;
	handler: (value: string) => void;
	textarea?: boolean;
	placeholder?: string;
	label?: string;
	error?: UserError;
	children?: ComponentChildren;
	className?: Maybe<string>;
}
interface State {
	id: string;
}
export class LabeledInput extends Component<LabeledInputProps, State> {

	constructor() {
		super();
		this.state = { id: generateId() };
	}

	render({ autocomplete, name, select, attributes, value, handler, label, placeholder, error, children, className, ...props }: LabeledInputProps, { id }: State) {
		return <div class={classNames(
			'labeled-input',
			select && '--select',
			!!value && '--value',
			error && '--error',
			className,
		)}>
			{!select ? <input
				id={id}
				type="text"
				name={name ?? autocomplete}
				autocomplete={autocomplete}
				value={value ?? ''}
				onInput={e => handler((e.target as HTMLTextAreaElement).value)}
				class={classNames('labeled-input__input', '--text')}
				placeholder={placeholder}
				{...attributes}
			/> : <select
				id={id}
				name={name ?? autocomplete}
				autocomplete={autocomplete}
				value={value ?? ''}
				onChange={e => handler(getEventValue(e))}
				class={classNames('labeled-input__input', '--select')}
				{...attributes}
			>
				{children}
			</select>}
			<label class="labeled-input__label" for={id}>
				<span class="labeled-input__label-text">{label}</span>
				{error && <span class="labeled-input__label-error">{' – '}{error.message ?? error.error}</span>}
			</label>
			{error && <span class="labeled-input__error">{error.message ?? error.error}</span>}
		</div>;
	}

	shouldComponentUpdate() {
		return this.base != document.activeElement;
	}

}
